import React from 'react';
import pt from 'prop-types';
import { combine } from '../../../helpers/styles';
import Image, { imageProptypes } from '../../ui/image';
import Text from '../../ui/text';
import Container from '../../../modules/container';
import RichText, { richTextPropTypes } from '../../ui/richText';
import * as styles from './quote.module.scss';

const CMSQuote = ({ image, name, text, useBlueBackground }) => (
  <Container
    fullWidth
    className={combine(
      styles.quoteWrapper,
      useBlueBackground && styles.blueBackground
    )}
  >
    <Container noGap className={styles.quote}>
      {image && (
        <div className={styles.image}>
          <Image {...image} />
        </div>
      )}
      <div className={styles.textWrapper}>
        {name && (
          <Text as="span" type="p1" className={styles.name}>
            {name}
          </Text>
        )}
        {text && (
          <RichText
            content={text}
            paragraphAs="span"
            paragraphVariant="h2"
            paragraphType="quoteText"
          />
        )}
      </div>
    </Container>
  </Container>
);

CMSQuote.propTypes = {
  image: pt.shape(imageProptypes),
  name: pt.string,
  text: pt.shape(richTextPropTypes),
  useBlueBackground: pt.bool,
};
CMSQuote.defaultProps = {
  useBlueBackground: false,
  name: '',
  text: '',
};

export default CMSQuote;
